















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormatUtils from '@/api/util/FormatUtils';
import EventDate from '@/components/EventDate.vue';

@Component({
  components: { EventDate },
})
export default class TicketCheckoutOrderSummary extends Vue {
  @Prop(Object) public readonly event!: any;
  @Prop(Object) public readonly summary!: any;

  get orderItems() {
    return this.summary.lineItems.sort(
      (a: any, b: any) => a.sortIndex - b.sortIndex,
    );
  }

  get orderTax() {
    return 0;
  }

  get orderSubtotal() {
    const totalPrice = this.summary.lineItems.reduce((acc, item) => {
      if (item.totalPromoPrice !== null) {
        acc += item.totalPromoPrice;
      } else if (item.totalPrice) {
        acc += item.totalPrice;
      }

      return acc;
    }, 0);

    return totalPrice;
  }

  get orderTotal() {
    return this.orderSubtotal + Number(this.summary.donationAmount || 0);
  }

  // ToDo: This is not reactive. Use a filter?
  private formatCurrency(amount) {
    return FormatUtils.formatCurrency(amount, this.event.currencyCode || 'USD');
  }
}
